"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useState } from 'react';
import { buildAssetUrl } from './buildAssetUrl';
const createResource = promise => {
  let status = 'pending';
  let result;
  const suspender = promise.then(data => {
    status = 'success';
    result = data;
  }, error => {
    status = 'error';
    result = error;
  });
  return {
    read() {
      if (status === 'pending') {
        throw suspender;
      }
      if (status === 'error') {
        throw result;
      }
      return result;
    }
  };
};
const manifestCache = {};
export const useMFEManifestFetch = ({
  mfeAppName,
  tenantName,
  staticMFEUrl
}) => {
  const [resource, setResource] = useState(null);
  useEffect(() => {
    // Create a unique key for each manifest
    const cacheKey = `${mfeAppName}-${tenantName}-${staticMFEUrl}`;

    // If the manifest is in the cache, use it
    if (manifestCache[cacheKey]) {
      setResource(createResource(Promise.resolve(manifestCache[cacheKey])));
    } else {
      // Otherwise, fetch the manifest and store it in the cache
      const fetchManifest = fetch(buildAssetUrl({
        asset: 'build-manifest.json',
        mfeAppName,
        staticMFEUrl
      })).then(res => res.json()).then(manifest => {
        manifestCache[cacheKey] = manifest;
        return manifest;
      });
      setResource(createResource(fetchManifest));
    }
  }, [mfeAppName, tenantName, staticMFEUrl]);
  return {
    manifest: resource === null || resource === void 0 ? void 0 : resource.read()
  };
};